/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import Icons from './icons/Icons';

function makeOption(option, intl) {
  const text = option.labelId ? intl.formatMessage({ id: option.labelId }) : option.label;
  return (
    <option key={option.value} value={option.value} disabled={option.isDisabled}>{text}</option>
  );
}

const DropdownList = (props) => (
  <div className="cmp-dropdown-list">
    <label htmlFor={props.name} className="cmp-dropdown-list--label">
      {props.label}
    </label>

    <div className="cmp-dropdown-list--content">

      <div className="cmp-dropdown-list-item--icon">
        <Icons.ArrowDropDown color="inactive" />
      </div>

      <select
        name={props.name}
        value={props.value}
        onFocus={props.onFocus}
        onBlur={props.onBlur}
        onChange={props.onChange}
      >
        {
          props.values.map((v) => (
            makeOption(v, props.intl)
          ))
        }
      </select>
    </div>
  </div>
);

DropdownList.propTypes = {
  intl: PropTypes.object,
  label: PropTypes.any,
  name: PropTypes.string,
  values: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.any,
    value: PropTypes.any,
    labelId: PropTypes.string,
    isDisabled: PropTypes.bool,
  })),
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
};

export default injectIntl(DropdownList);
